'use strict';

var debounce = require('lodash/debounce');
var minChars = 3;
var ENTER = 13;
var UP_KEY = 38;
var DOWN_KEY = 40;
var DIRECTION_DOWN = 1;
var DIRECTION_UP = -1;
var ESC = 27;
var showAllObserver = null;

/**
 * Retrieves Suggestions element relative to scope
 *
 * @param {Object} scope - Search input field DOM element
 * @return {JQuery} - .suggestions-wrapper element
 */
function getSuggestionsWrapper(scope) {
    return $(scope).closest('form').find('.suggestions-wrapper');
}

/**
 * Restores the initial search view: top recommendations (product groups +
 * suggested terms) visible, all previous search results removed — injected
 * categories, product grid, show-all button.
 *
 * @param {JQuery} $form - the simpleSearch form
 * @param {JQuery} $sheet - the enclosing .mm-sheet
 */
function restoreInitialState($form, $sheet) {
    var $recommendationsTop = $form.find('.search-recommendations-top');
    $form.find('.suggestions-wrapper').empty().hide();
    $form.find('.search-results').addClass('d-none');
    $sheet.removeClass('has-results');
    $recommendationsTop.find('.injected-categories').remove();
    $form.find('.js-suggestions-view-all').remove();
    $recommendationsTop.children().not('.injected-categories').removeClass('d-none');
    $form.find('.page-search-result-container').removeClass('d-none');
    // No results left to observe
    if (showAllObserver) {
        showAllObserver.disconnect();
        showAllObserver = null;
        $(window).off('resize.searchShowAll');
    }
}

/**
 * Process Ajax response for SearchServices-GetSuggestions
 *
 * @param {Object|string} response - Empty object literal if null response or string with rendered
 *                                   suggestions template contents
 */
function processResponse(response) {
    var $suggestionsWrapper = getSuggestionsWrapper(this);
    var $sheet = $(this).closest('.mm-sheet');
    var $form = $(this).closest('form');
    var $recommendationsTop = $form.find('.search-recommendations-top');

    if (typeof (response) === 'string' && response.trim().length > 0) {
        var $html = $('<div>').append($.parseHTML(response));
        
        // Extract category section (title + list) and show-all button
        var $categoryTitle = $html.find('.suggestions-categories-title');
        var $categoryList = $html.find('.suggestions-categories-list');
        var $showAll = $html.find('.js-suggestions-view-all');

        var hasResults = $html.find('.js-product-card').length > 0 || $categoryList.length > 0 || $showAll.length > 0;

        if (!hasResults) {
            restoreInitialState($form, $sheet);
            return;
        }

        // Check if suggestions are identical to currently shown ones
        var newPids = $html.find('.js-product-card').map(function() { return $(this).data('pid'); }).get().join(',');
        var newCats = $categoryList.find('.category-item a').map(function() { return $(this).attr('href'); }).get().join(',');

        var currentPids = $suggestionsWrapper.find('.js-product-card').map(function() { return $(this).data('pid'); }).get().join(',');
        var currentCats = $recommendationsTop.find('.injected-categories .suggestions-categories-list .category-item a').map(function() { return $(this).attr('href'); }).get().join(',');

        var productsChanged = newPids !== currentPids;
        var categoriesChanged = newCats !== currentCats;

        if (!productsChanged && !categoriesChanged) {
            var newViewAllHref = $html.find('.js-suggestions-view-all a').attr('href');
            var newGridAllHref = $html.find('.js-grid-view-all-container a').attr('href');

            if (newViewAllHref) {
                $form.find('.js-suggestions-view-all a').attr('href', newViewAllHref);
            }
            if (newGridAllHref) {
                $suggestionsWrapper.find('.js-grid-view-all-container a').attr('href', newGridAllHref);
            }
            return;
        }

        // 1. Update Categories if they changed
        if (categoriesChanged) {
            $recommendationsTop.find('.injected-categories').remove();
            $form.find('.js-suggestions-view-all').remove();

            if ($categoryList.length > 0) {
                var $injectedWrapper = $('<div class="injected-categories"></div>');
                
                if ($categoryList.length > 0) {
                    $injectedWrapper.append($categoryTitle).append($categoryList);
                }
                
                if ($showAll.length > 0) {
                    if (!window.isMobile()) {
                        $recommendationsTop.after($showAll);
                    } else {
                        $injectedWrapper.append($showAll);
                    }
                }
                
                $recommendationsTop.append($injectedWrapper);
                $recommendationsTop.children().not('.injected-categories').addClass('d-none');
                $form.find('.page-search-result-container').addClass('d-none');
            } else {
                $recommendationsTop.children().not('.injected-categories').removeClass('d-none');
                $form.find('.page-search-result-container').removeClass('d-none');
            }
        }

        // 2. Update Products if they changed
        if (productsChanged) {
            $suggestionsWrapper.empty();
            
            // Remove category section and show-all from the HTML clone before putting it into suggestionsWrapper
            var $htmlProducts = $html.clone();
            $htmlProducts.find('.suggestions-categories-title').remove();
            $htmlProducts.find('.suggestions-categories-list').remove();
            $htmlProducts.find('.js-suggestions-view-all').remove();

            if ($htmlProducts.find('.js-product-card').length > 0) {
                $suggestionsWrapper.append($htmlProducts.contents()).show();
            } else {
                $suggestionsWrapper.hide();
            }
        } else if ($html.find('.js-product-card').length === 0) {
            $suggestionsWrapper.hide();
        }

        // 3. Update Observer if either changed
        if (productsChanged || categoriesChanged) {
            if (showAllObserver) {
                showAllObserver.disconnect();
                showAllObserver = null;
                $(window).off('resize.searchShowAll');
            }

            var $productsShowAll = $suggestionsWrapper.find('.js-grid-view-all-container');
            var $topShowAll = $form.find('.js-suggestions-view-all');

            if ($productsShowAll.length > 0 && $topShowAll.length > 0 && window.IntersectionObserver) {
                showAllObserver = new IntersectionObserver(function(entries) {
                    entries.forEach(function(entry) {
                        if (entry.isIntersecting) {
                            $topShowAll.addClass('d-none').removeClass('d-md-block');
                        } else {
                            $topShowAll.removeClass('d-none').addClass('d-md-block');
                        }
                    });
                });

                var manageObserver = function() {
                    if (window.isMobile()) {
                        showAllObserver.disconnect();
                        $topShowAll.addClass('d-none').removeClass('d-md-block'); 
                    } else {
                        showAllObserver.observe($productsShowAll[0]);
                    }
                };

                manageObserver();
                $(window).on('resize.searchShowAll', debounce(manageObserver, 250));
            }
        }

        if ($suggestionsWrapper.find('.suggestions-products-grid .js-product-card').length > 0) {
            $form.find('.search-results').removeClass('d-none');
            $sheet.addClass('has-results');
            $form.find('.page-search-result-container').addClass('d-none');
        } else {
            $sheet.removeClass('has-results');
        }
    } else {
        restoreInitialState($form, $sheet);
    }
}

/**
 * Retrieve suggestions
 *
 * @param {Object} scope - Search field DOM element
 */
function getSuggestions(scope) {
    var $form = $(scope).closest('form');
    var endpoint = $form.find('.suggestions-wrapper').data('url');
    var $sheet = $(scope).closest('.mm-sheet');

    if ($(scope).val().length >= minChars) {
        var gcat = $form.data('gcat') || '';
        $.ajax({
            context: scope,
            url: endpoint + encodeURIComponent($(scope).val()) + '&qbrand=' + encodeURIComponent(gcat),
            method: 'GET',
            success: processResponse,
            error: function () {
                // handle error if needed
            }
        });
    } else {
        restoreInitialState($form, $sheet);
    }
}

/**
 * Handle Search Suggestion Keyboard Arrow Keys
 *
 * @param {Integer} direction takes positive or negative number constant, DIRECTION_UP (-1) or DIRECTION_DOWN (+1)
 */
function handleArrow(scope, direction) {
    var $form = $(scope).closest('form');
    var suggestionsList = $form.find('.suggestions .item');
    if (suggestionsList.length === 0) return;

    if (suggestionsList.filter('.selected').length === 0) {
        suggestionsList.first().addClass('selected');
    } else {
        var current = suggestionsList.filter('.selected');
        var index = suggestionsList.index(current);
        var nextIndex = index + direction;

        if (nextIndex < 0) nextIndex = suggestionsList.length - 1;
        if (nextIndex >= suggestionsList.length) nextIndex = 0;

        current.removeClass('selected');
        suggestionsList.eq(nextIndex).addClass('selected');
        $(scope).attr('aria-activedescendant', suggestionsList.eq(nextIndex).attr('id'));
    }
}

function handleEnter(scope, e) {
    var $form = $(scope).closest('form');
    var selected = $form.find('.suggestions .item.selected');
    if (selected.length > 0) {
        e.preventDefault();
        selected.find('a')[0].click();
    }
}

module.exports = function () {
    var $forms = $('form[name="simpleSearch"]');

    // search_open (int_mf_tealium tealiumEvents.searchOpen). Legacy fired it from
    // MMSearchComponent, the component that toggled the old search panel; the revamp has no
    // such component, so the event is tied to the sheet actually opening: MMSheet announces
    // every opening with MMSheet:opening, header buttons included.
    //
    // NOT a delegated click handler on body: the header search buttons are MMTriggerComponent
    // instances and BaseComponent.$on calls e.stopPropagation() on every event it binds, so
    // their clicks never reach body and a delegated binding silently loses search_open.
    // Listening to the opening also avoids tracking clicks that open nothing.
    // The in-menu entry point does not go through MMSheet: MMNavigationMenu fires the event
    // itself in handleSearchClick().
    // MMSheet.opening() announces every call, also when the sheet is already open (clicking the
    // header button twice), so keep the state and report one search_open per actual opening.
    var searchSheetOpen = false;

    document.addEventListener('MMSheet:opening', function (e) {
        var sheet = e.detail && e.detail.element;

        if (!sheet || sheet.id !== 'header-search-sheet' || searchSheetOpen) return;

        searchSheetOpen = true;
        $('body').trigger('search:open');
    });

    document.addEventListener('MMSheet:closed', function (e) {
        var sheet = e.detail && e.detail.element;

        if (sheet && sheet.id === 'header-search-sheet') {
            searchSheetOpen = false;
        }
    });

    $forms.each(function() {
        var $form = $(this);
        var $input = $form.find('input.search-field');
        var $resetBtn = $form.find('.js-search-reset-btn');
        var $searchBtn = $form.find('.js-search-submit');
        var debounceSuggestions = debounce(function(scope) { getSuggestions(scope); }, 300);

        // Clear/search CTAs are visible on focus but stay disabled until the user types
        var toggleActionButtons = function () {
            var val = $input.val();
            var isEmpty = !val || val.length === 0;
            $resetBtn.prop('disabled', isEmpty);
            $searchBtn.prop('disabled', isEmpty);
        };

        toggleActionButtons();
        $input.on('input', toggleActionButtons);

        // Clicking the CTA area must never blur the input: with the input empty the
        // CTAs are disabled (pointer-events: none) and losing :focus-within would hide them
        $form.find('.action-buttons').on('mousedown touchstart', function (e) {
            e.preventDefault();
        });

        $input.on('keyup', function (e) {
            switch (e.which) {
                case DOWN_KEY:
                    handleArrow(this, DIRECTION_DOWN);
                    e.preventDefault();
                    break;
                case UP_KEY:
                    handleArrow(this, DIRECTION_UP);
                    e.preventDefault();
                    break;
                default:
                    if (e.which !== ENTER) {
                        debounceSuggestions(this);
                    }
            }
        });

        $input.on('keypress', function (e) {
            if (e.which === ENTER) {
                handleEnter(this, e);
            }
        });

        $resetBtn.on('click touchstart', function (e) {
            e.preventDefault();
            if (this.disabled) return;
            $input.val('');
            toggleActionButtons();
            getSuggestions($input[0]);
            $(this).closest('.mm-sheet').removeClass('has-results');
        });

        $form.on('submit', function (e) {
            var $selected = $form.find('.suggestions .item.selected');
            if ($selected.length > 0) {
                e.preventDefault();
                $selected.find('a')[0].click();
            } else {
                var $viewAll = $form.find('.js-suggestions-view-all');
                var $gridAll = $form.find('.js-grid-view-all-container');
                if ($viewAll.length > 0) {
                    e.preventDefault();
                    $viewAll.find('a')[0].click();
                } else if ($gridAll.length > 0) {
                    e.preventDefault();
                    $gridAll.find('a')[0].click();
                }
            }
        });

        $searchBtn.on('click touchstart', function (e) {
            e.preventDefault();
            if (this.disabled) return;
            var event = $.Event('submit');
            $form.trigger(event);
            if (!event.isDefaultPrevented()) {
                $form[0].submit();
            }
        });
    });
};
